import styled, { css } from 'styled-components'
import { Link as ReactLink } from 'react-router-dom'

const LinkStyle = css`
  color: ${({ color }) => color};
  transition: all 0.3s;
  &:hover:not(:disabled) {
    color: ${({ color }) => color};
    opacity: 0.7;
    text-decoration: none;
  }
`

export const DisabledLink = styled.div`
  color: ${({ color }) => color};
  opacity: 0.7;
  cursor: not-allowed;
`

export const ExternalLink = styled.a`
  ${LinkStyle}
`

export const InternalLink = styled(ReactLink)`
  ${LinkStyle}
`
